import { render, staticRenderFns } from "./honor.vue?vue&type=template&id=9a820dbc&scoped=true"
import script from "./honor.vue?vue&type=script&lang=js"
export * from "./honor.vue?vue&type=script&lang=js"
import style0 from "./honor.vue?vue&type=style&index=0&id=9a820dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a820dbc",
  null
  
)

export default component.exports